import React, { useEffect, useState } from "react";
import { components } from "../components";
import { theme } from "../constants";
import SuccessModal from "../components/nodataFound/SuccessModal";
import { useLocation } from "react-router-dom";
import {
  fetchBookingAmount,
  leadIdFromStorage,
  propertyTanantAdd,
  updateLeadProfile,
  updatePaymentStatus,
  viewLeadProfile,
} from "../environment";
import useApi from "../customHook/useApi";
import { toast } from "react-toastify";
import { hooks } from "../hooks";

interface UserFormData {
  fullName: string;
  gender: string;
  country_code: string;
  contact_number: string;
  is_b2b_user: string;
  occupation: string;
  email: string;
  property_id: string;
  property_room_option_id: string;
  room_type_id: string;
  lead_profile_id: string;
  movein_date?: string;
  // amount: number;
}

type Profile = {
  full_name: string | null;
  email: string | null;
  phone_number: string | null;
  gender: string | null;
  dob: string | null;
  pref_budget_min_range: number | null;
  pref_budget_max_range: number | null;
  pref_city_name: string | null;
  pref_city_id: number | null;
  pref_locality_id: number | null;
};

export interface profileResponse {
  success: boolean;
  statusCode: number;
  data: Profile;
  // message?: string;
}

declare global {
  interface Window {
    Razorpay: any;
  }
}

export const BookingModal: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const initialFormData: UserFormData = {
    fullName: "",
    gender: "",
    country_code: "91",
    contact_number: "",
    is_b2b_user: "No",
    occupation: "",
    email: "",
    property_id: "",
    property_room_option_id: "",
    room_type_id: "",
    lead_profile_id: localStorage.getItem("lead_profile_id") || "",
    movein_date: "",
    // amount: parseInt(localStorage.getItem("p") || "0") || 0,
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState<UserFormData>(initialFormData);

  const navigate = hooks.useNavigate();

  const location = useLocation();
  const room = location.state?.room;
  const propertyData = location.state?.propertyData;
  // console.log(room, "Room Updatre");
  // console.log(propertyData, "propertyData....... Room Updatre");

  // console.log(location.state);

  // update room id
  useEffect(() => {
    // Check if room data is coming via location.state
    const room = location.state?.room;
    // console.log("-- room --", room);

    if (room) {
      setFormData((prev) => ({
        ...prev,
        room_type_id: room.room_type_id ?? room.preffered_room_type ?? "",
        property_id: room.property_id ?? "",
        property_room_option_id:
          room.property_room_option_id ?? room.preffered_room_option ?? "",
      }));

      // console.log("Form updated with room data:", room);
    }
  }, [location]);

  // console.log("Selected room:", room);

  // API for fetch booking amount
  const {
    data: fetchAmountData,
    loading: fetchAmountLoading,
    callApi: fetchBookingAmountData,
  } = useApi<any>(fetchBookingAmount, {
    method: "GET",
    autoCall: false,
    isBinary: false,
  });

  // API CALL FOR BOOKING
  // API CALL
  const {
    data: submitResponse,
    loading: submitLoading,
    callApi: submitTenant,
  } = useApi<any>(propertyTanantAdd, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  //   // --- useApi updatePaymentStatus ---
  const {
    data: paymentResponse,
    loading: paymentLoading,
    callApi: updatePaymentStatusApi,
  } = useApi<any>(updatePaymentStatus, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // update profile data
  // API CALL FOR UPDATE DATA
  const {
    data: UpdateProfileData,
    loading: UpdateProfileLoading,
    callApi: updatePayload,
  } = useApi<profileResponse>(updateLeadProfile, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // API CALL FOR /view-lead-profile
  const {
    data: profileData,
    loading: profileLoading,
    callApi: fetchProfile,
  } = useApi<profileResponse>(viewLeadProfile, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // 1. API Call Trigger (on mount)
  useEffect(() => {
    const leadId = localStorage.getItem("lead_profile_id") ?? "";
    if (leadId) {
      fetchProfile({ leadId });
    }
  }, []);

  useEffect(() => {
    if (profileData?.data) {
      const data = profileData.data;
      setFormData((prev) => ({
        ...prev,
        fullName: data.full_name ?? "",
        gender: data.gender ?? "",
        contact_number: data.phone_number ?? "",
        email: data.email ?? "",
      }));
      // console.log("Form prefilled with API data:", data);
    }
  }, [profileData]);

  useEffect(() => {
    if (UpdateProfileData?.success) {
      console.log("Profile updated successfully");
    }
  }, [UpdateProfileData]);

  const handleUpdateProfile = () => {
    // console.log("Form DAta", formData.fullName);
    const updatedPayload = {
      leadId: leadIdFromStorage,
      full_name: formData.fullName,
      email: formData.email,
      phone_number: formData.contact_number,
      gender: formData.gender,
      dob: profileData?.data?.dob,
      pref_budget_min_range: profileData?.data?.pref_budget_min_range,
      pref_budget_max_range: profileData?.data?.pref_budget_max_range,
      pref_city_id: profileData?.data?.pref_city_id,
      pref_locality_id: profileData?.data?.pref_locality_id,
    };
    // console.log("Final update profile payload:", updatedPayload);
    updatePayload(updatedPayload);
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = (): string | null => {
    if (!formData.fullName?.trim()) {
      return "Full Name is required";
    } else if (formData.fullName.trim().length < 3) {
      return "Full Name must be at least 3 characters";
    } else if (formData.fullName.trim().length > 50) {
      return "Full Name must not exceed 15 characters";
    }

    if (!formData.gender) {
      return "Please select your gender";
    }

    if (!formData.contact_number?.trim()) {
      return "Contact Number is required";
    } else if (!/^\d{10}$/.test(formData.contact_number)) {
      return "Contact Number must be exactly 10 digits";
    }

    if (!formData.email?.trim()) {
      return "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      return "Enter a valid email";
    }

    if (!formData.occupation) {
      return "Occupation is required";
    }

    if (!formData.is_b2b_user) {
      return "Please select B2B user type";
    }
    if (!formData.movein_date?.trim()) {
      return "Move-in Date is required";
    }

    return null;
  };

  // --- Razorpay Payment Handler ---
  const updateStatus = async (
    booking_id: string,
    status: "success" | "failed" | "cancelled",
    transaction_id: string,
    amount: number,
    orderId?: string,
    signature?: string
  ) => {
    await updatePaymentStatusApi({
      body: {
        booking_id,
        payment_status: status,
        transaction_id,
        amount,
        payment_order_id: orderId,
        payment_signature: signature,
      },
    });
  };

  // const payNow = ({
  //   email,
  //   contact,
  //   name,
  //   amount = 0,
  //   booking_id,
  // }: {
  //   email: string;
  //   contact: string;
  //   name: string;
  //   amount?: number;
  //   booking_id: string;
  // }): Promise<{ razorpay_payment_id: string }> => {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       const rzp = new (window as any).Razorpay({
  //         key: process.env.REACT_APP_RAZOR_PAY_API_KEY,
  //         amount: amount * 100,
  //         currency: "INR",
  //         name: "Nestfin",
  //         description: "Payment for services",
  //         image: "/assets/nestfin/Nestfin_logo.png",
  //         prefill: { email, contact, name },
  //         theme: { color: "#7065F0" },

  //         handler: async function (response: any) {
  //           const paymentId = response?.razorpay_payment_id || "";
  //           toast.success("Payment successful!");
  //           console.log("payment successful", response);
  //           await updateStatus(booking_id, "success", paymentId, amount);

  //           resolve({ razorpay_payment_id: paymentId });
  //         },

  //         modal: {
  //           ondismiss: async (response: any) => {
  //             toast.error("Payment cancelled by user");
  //             // console.log("payment cancelled", response);

  //             await updateStatus(booking_id, "cancelled", "", amount);
  //             // rzp.close();
  //             // reject(new Error("Payment cancelled"));
  //           },
  //         },
  //       });

  //       rzp.on("payment.failed", async (response: any) => {
  //         // console.log("payment failed", response);
  //         const paymentId = response?.error?.metadata?.payment_id || "";
  //         await updateStatus(booking_id, "failed", paymentId, amount);

  //         toast.error("Payment failed");
  //         // rzp.close();
  //         // reject(new Error("Payment failed"));
  //       });

  //       rzp.open();
  //     } catch (err) {
  //       reject(err);
  //     }
  //   });
  // };
  const payNow = ({
    email,
    contact,
    name,
    amount = 0,
    booking_id,
    order_id,
  }: {
    email: string;
    contact: string;
    name: string;
    amount?: number;
    booking_id: string;
    order_id: string;
  }): Promise<{
    razorpay_payment_id: string;
    razorpay_order_id: string;
    razorpay_signature: string;
  }> => {
    return new Promise(async (resolve, reject) => {
      try {
        // let paymentId = "testing_payment",
        //   orderId = "order_RuehZrwf3FbK1d",
        //   signature =
        //     "e0d9c7d1f5b4a2d9c9e9c9dcb65a8cbbd93b9b1a7c2e9b88c7cdbd5a8c4e1a22";

        // await updateStatus(
        //   booking_id,
        //   "success",
        //   paymentId,
        //   amount,
        //   orderId,
        //   signature
        // );
        // return;

        const rzp = new (window as any).Razorpay({
          key: process.env.REACT_APP_RAZOR_PAY_API_KEY,
          amount: amount * 100,
          currency: "INR",
          name: "Nestfin",
          description: "Payment for services",
          image: "/assets/nestfin/Nestfin_logo.png",
          prefill: { email, contact, name },
          theme: { color: "#7065F0" },
          order_id: order_id,

          handler: async function (response: any) {
            // console.log("razorpay response", response);

            const orderId = response.razorpay_order_id || "";
            const paymentId = response.razorpay_payment_id || "";
            const signature = response.razorpay_signature || "";
            toast.success("Payment successful!");
            // console.log("payment successful", response);
            await updateStatus(
              booking_id,
              "success",
              paymentId,
              amount,
              orderId,
              signature
            );

            resolve({
              razorpay_payment_id: paymentId,
              razorpay_order_id: orderId,
              razorpay_signature: signature,
            });
          },

          modal: {
            ondismiss: async (response: any) => {
              toast.error("Payment cancelled by user");
              // console.log("payment cancelled", response);

              await updateStatus(booking_id, "cancelled", "", amount);
              // rzp.close();
              // reject(new Error("Payment cancelled"));
            },
          },
        });

        rzp.on("payment.failed", async (response: any) => {
          // console.log("payment failed", response);
          const paymentId = response?.error?.metadata?.payment_id || "";
          await updateStatus(booking_id, "failed", paymentId, amount);

          toast.error("Payment failed");
          // rzp.close();
          // reject(new Error("Payment failed"));
        });

        rzp.open();
      } catch (err) {
        reject(err);
      }
    });
  };

  // console.log(location);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const errorMessage = validateForm();
    if (errorMessage) return toast.error(errorMessage);
    try {
      setIsSubmitting(true);
      const bookingdata = await fetchBookingAmountData();
      const tenantResponse = await submitTenant({ ...formData });
      // console.log(bookingdata);
      // console.log(
      //   " data data data rns",
      //   tenantResponse?.success,
      //   tenantResponse?.booking_id,
      //   bookingdata?.amount
      // );
      if (
        !tenantResponse?.success ||
        !tenantResponse?.booking_id ||
        !bookingdata?.amount
      ) {
        toast.error("Booking failed. Cannot continue to payment.");
        return;
      }
      console.log("tenantResponse", tenantResponse);
      setIsSubmitting(false);
      const booking_id = tenantResponse.booking_id;
      const booking_amount = bookingdata?.amount;
      try {
        const paymentResponse = await payNow({
          email: formData.email,
          contact: formData.country_code + formData.contact_number,
          name: formData.fullName,
          amount: booking_amount,
          booking_id,
          order_id: tenantResponse?.order_id,
        });

        navigate("/payment-detail", {
          state: {
            amount: booking_amount,
            // amount: 1000,
            email: formData.email,
            contact: formData.country_code + formData.contact_number,
            name: formData.fullName,
            booking_id,
            property_name: propertyData?.property_name,
            upi_id: "nestfin@upi",
            upi_ref: paymentResponse.razorpay_payment_id,
            latitude: propertyData?.latitude,
            longitude: propertyData?.longitude,
            house_flat_block_no: propertyData?.house_flat_block_no,
            address: propertyData?.address,
          },
        });
      } catch (paymentErr) {
        console.error("Payment flow error:", paymentErr);
        setIsSubmitting(true);
      }
    } catch (error) {
      toast.error("Booking request failed. Try again.");
      console.error("Booking API error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // ------ end payment -------

  const renderHeader = () => (
    <components.Header
      title="Booking Form"
      goBack={true}
      style={{ backgroundColor: theme.colors.transparent }}
    />
  );

  const newDate = new Date();
  const todayDate = `${newDate.getFullYear()}-${
    newDate.getMonth() + 1
  }-${newDate.getDate()}`;

  const renderContent = () => (
    <main style={{ paddingTop: "80px", paddingBottom: 0 }}>
      <form onSubmit={handleSubmit} className="form-container">
        {/* Property Details Section */}
        <div
          className="container propertiesDetails"
          style={{
            // marginTop: "40px",
            padding: "0px 0px",
            paddingBottom: "20px",
          }}
        >
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "700",
              color: "#2c3e50",
              marginBottom: "10px",
              textTransform: "capitalize",
            }}
          >
            {propertyData?.property_name || ""}
          </h2>

          {propertyData?.locality_name && propertyData?.state && (
            <p
              style={{
                fontSize: "1.1rem",
                color: "#777",
                margin: "4px 0",
              }}
            >
              {propertyData.locality_name}, {propertyData.state}
            </p>
          )}

          {/* {propertyData?.state && (
            <p
              style={{
                fontSize: "1.1rem",
                color: "#555",
                margin: "4px 0",
              }}
            >
              {propertyData?.state}
            </p>
          )} */}
        </div>

        {/* Full Name */}
        <div className="form-group">
          <label className="form-label">Full Name</label>
          <input
            type="text"
            name="fullName"
            className="form-input"
            placeholder="Enter Full Name"
            value={formData.fullName ?? ""}
            onChange={handleChange}
          />
        </div>

        {/* Gender */}
        <div className="form-group">
          <label className="form-label">Gender</label>
          <select
            name="gender"
            className="form-input"
            value={formData.gender ?? ""}
            onChange={handleChange}
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>

        {/* Contact Number */}
        <div className="form-group">
          <label className="form-label">Contact Number</label>
          <input
            type="text"
            name="contact_number"
            className="form-input"
            placeholder="Enter Contact Number"
            maxLength={10}
            value={formData.contact_number ?? ""}
            onChange={handleChange}
          />
        </div>

        {/* Email */}
        <div className="form-group">
          <label className="form-label">Email</label>
          <input
            type="email"
            name="email"
            className="form-input"
            placeholder="Enter Email"
            value={formData.email ?? ""}
            onChange={handleChange}
          />
        </div>

        {/* Occupation / Status */}
        <div className="form-group">
          <label className="form-label">Occupation</label>
          <select
            name="occupation"
            className="form-input"
            value={formData.occupation ?? ""}
            onChange={handleChange}
          >
            <option value="">Select Occupation</option>
            <option value="Working">Working</option>
            <option value="Student">Student</option>
          </select>
        </div>

        {/* Movein Date */}
        <div className="form-group">
          <label className="form-label">Move-in Date</label>
          <input
            type="date"
            // min={String(new Date().getDate()) || ""}
            min={todayDate}
            name="movein_date"
            className="form-input"
            value={formData.movein_date}
            onClick={(e) => {
              e.currentTarget?.showPicker?.();
              console.log(todayDate);
            }}
            // onClick={(e) => console.log(new Date().)}
            onChange={handleChange}
          />
        </div>

        {/* Terms & Conditions Checkbox */}
        {/* <div className="form-group" style={{ marginTop: '1rem' }}>
          <label className="form-check-label" style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              name="agree_terms"
              required
              style={{ marginRight: '8px' }}
            />
            I agree to the{' '}
            <a
              href="/payment-terms-conditions"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#007bff', marginLeft: '4px', textDecoration: 'underline' }}
            >
              Terms & Conditions
            </a>
          </label>
        </div> */}

        {/* Terms & Conditions Checkbox */}
        <div className="form-group" style={{ marginTop: "1rem" }}>
          <label
            className="form-check-label"
            style={{ display: "flex", alignItems: "center" }}
          >
            <input
              type="checkbox"
              name="agree_terms"
              required
              onInvalid={(e) =>
                e.currentTarget.setCustomValidity(
                  "Please agree to the Terms & Conditions before booking."
                )
              }
              onInput={(e) => e.currentTarget.setCustomValidity("")}
              style={{ marginRight: "8px" }}
            />
            I agree to the{" "}
            <a
              href="/payment-terms-conditions"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#007bff",
                marginLeft: "4px",
                textDecoration: "underline",
              }}
            >
              Terms & Conditions
            </a>
          </label>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "right",
            marginBottom: "20px",
          }}
        >
          <button
            type="submit"
            className="form-button"
            disabled={isSubmitting}
            style={{ opacity: isSubmitting ? "0.6" : 1 }}
          >
            Confirm & Pay
          </button>
        </div>
      </form>

      {/* Success Modal */}
      <SuccessModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        message="Form submitted successfully!"
        subMessage="Your data has been saved."
        imgSrc={require("../assets/nestfin/checklist.png")}
      />
    </main>
  );

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};

// -=-=-=== old commented form ==-=-=-=-=-=-
//     <main style={{ paddingBottom: 0 }}>
//          <div
//   className="container propertiesDetails"
//   style={{
//     marginTop: "40px",
//     padding: "20px 30px",
//   }}
// >
//   <h2
//     style={{
//       fontSize: "1.5rem",
//       fontWeight: "700",
//       color: "#2c3e50",
//       marginBottom: "10px",
//       textTransform: "capitalize",
//     }}
//   >
//     {propertyData?.property_name || "Property Name"}
//   </h2>

//   {propertyData?.state && (
//     <p
//       style={{
//         fontSize: "1.1rem",
//         color: "#555",
//         margin: "4px 0",
//       }}
//     >
//       {propertyData.state}
//     </p>
//   )}

//   {propertyData?.locality_name && (
//     <p
//       style={{
//         fontSize: "1.1rem",
//         color: "#777",
//         margin: "4px 0",
//       }}
//     >
//       {propertyData.locality_name}
//     </p>
//   )}
// </div>
//       <form onSubmit={handleSubmit} className="form-container">
//         {/* Full Name */}
//         <div className="form-group">
//           <label className="form-label">Full Name</label>
//           <input
//             type="text"
//             name="fullName"
//             className="form-input"
//             placeholder="Enter Full Name"
//             value={formData.fullName}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Gender */}
//         <div className="form-group">
//           <label className="form-label">Gender</label>
//           <select
//             name="gender"
//             className="form-input"
//             value={formData.gender}
//             onChange={handleChange}
//           >
//             <option value="">Select Gender</option>
//             <option value="Male">Male</option>
//             <option value="Female">Female</option>
//             <option value="Other">Other</option>
//           </select>
//         </div>

//         {/* Contact Number */}
//         <div className="form-group">
//           <label className="form-label">Contact Number</label>
//           <input
//             type="text"
//             name="contact_number"
//             className="form-input"
//             placeholder="Enter Contact Number"
//             maxLength={10}
//             value={formData.contact_number}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Email */}
//         <div className="form-group">
//           <label className="form-label">Email</label>
//           <input
//             type="email"
//             name="email"
//             className="form-input"
//             placeholder="Enter Email"
//             value={formData.email}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Occupation / Status */}
//         <div className="form-group">
//           <label className="form-label">Status</label>
//           <select
//             name="occupation"
//             className="form-input"
//             value={formData.occupation}
//             onChange={handleChange}
//           >
//             <option value="">Select Status</option>
//             <option value="Working">Working</option>
//             <option value="Student">Student</option>
//           </select>
//         </div>

//         {/* Move Date */}
//         <div className="form-group">
//           <label className="form-label">Movein Date</label>
//           <input
//             type="date"
//             name="movein_date"
//             className="form-input"
//             value={formData.movein_date}
//             onChange={handleChange}
//           />
//         </div>

//         <div style={{ display: "flex", justifyContent: "right" }}>
//           <button className="form-button" type="submit">
//             Pay Now
//           </button>
//         </div>
//       </form>

//       <SuccessModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         message="Form submitted successfully!"
//         subMessage="Your data has been saved."
//         imgSrc={require("../assets/nestfin/checklist.png")}
//       />
//     </main>
// -=-=-=== old commented form ==-=-=-=-=-=-

// // =-======== pay now ==========-
//  const payNow = ({
//     email,
//     contact,
//     name,
//     amount = 1,
//     booking_id,
//   }: {
//     email: string;
//     contact: string;
//     name: string;
//     amount?: number;
//     booking_id: string;
//   }): Promise<{ razorpay_payment_id: string }> => {
//     return new Promise<{ razorpay_payment_id: string }>((resolve, reject) => {
//       try {
//         // console.log(process.env.REACT_APP_RAZOR_PAY_API_KEY);
//         const options = {
//           description: "Payment for services",
//           // image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
//           image: "/assets/nestfin/Nestfin_logo.png",
//           currency: "INR",
//           key: process.env.REACT_APP_RAZOR_PAY_API_KEY,
//           amount: amount * 100,
//           name: "Nestfin",
//           prefill: { email, contact, name },
//           theme: { color: "#7065F0" },

//           handler: async function (response: any) {
//             // console.log("Payment Success:", response);
//             toast.success("Payment successful!");
//             const { razorpay_payment_id } = response;

//             await updatePaymentStatusApi({
//               body: {
//                 booking_id,
//                 payment_status: "success",
//                 transaction_id: razorpay_payment_id,
//                 amount,
//               },
//             });

//             resolve({ razorpay_payment_id });
//           },
//           // <mark>
//           modal: {
//             ondismiss: async () => {
//               toast.error("Payment cancelled by user");

//               await updatePaymentStatusApi({
//                 body: {
//                   booking_id,
//                   payment_status: "cancelled",
//                   transaction_id: "",
//                   amount,
//                 },
//               });

//               reject(new Error("Payment cancelled"));
//             },
//           },
//           // </mark>
//         };

//         const rzp = new (window as any).Razorpay(options);

//         rzp.on("payment.cancel", async (response: any) => {
//           toast.error("Payment cancelled !");
//           console.log("Payment cancelled by user:", response);

//           await updatePaymentStatusApi({
//             body: {
//               booking_id,
//               payment_status: "cancelled",
//               transaction_id: "",
//               amount,
//             },
//           });
//           reject(new Error("Payment cancelled"));
//         });

//         rzp.on("payment.failed", async function (response: any) {
//           console.log("Payment Failed:", response);
//           toast.error("Payment failed. Please try again.");
//           const payment_id = response?.error?.metadata?.payment_id || "";

//           await updatePaymentStatusApi({
//             body: {
//               booking_id,
//               payment_status: "failed",
//               transaction_id: payment_id,
//               amount,
//             },
//           });
//           reject(response); // reject instead of resolve
//         });

//         rzp.open();
//       } catch (err: any) {
//         console.error("Unexpected error:", err);
//         // toast.error("Payment initialization failed");
//         reject(err);
//       }
//     });
//   };

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();

//     // Validate form
//     const errorMessage = validateForm();
//     if (errorMessage) {
//       toast.error(errorMessage);
//       return;
//     }
//     try {
//       const payload = { ...formData };
//       // Call API
//       const tenantResponse = await submitTenant(payload);
//       // console.log("API Response:", tenantResponse.booking_id);

//       if (tenantResponse?.success) {
//         const booking_id = tenantResponse?.booking_id;
//         if (!booking_id) {
//           toast.error("Booking ID not found, cannot continue payment");
//           return;
//         }
//         try {
//           // Wait for payment and capture response
//           const paymentResponse = await payNow({
//             email: formData.email,
//             contact: formData.country_code + formData.contact_number,
//             name: formData.fullName,
//             amount: 1,
//             // amount: 1000,
//             booking_id,
//           });
//           // console.log("paymentResponse ----", paymentResponse);
//           navigate("/payment-detail", {
//             state: {
//               amount: 1,
//               // amount: 1000,
//               email: formData?.email,
//               contact: formData?.country_code + formData?.contact_number,
//               name: formData?.fullName,
//               booking_id,
//               property_name: propertyData?.property_name,
//               upi_id: "nestfin@upi",
//               upi_ref: paymentResponse?.razorpay_payment_id || "N/A",
//               latitude: propertyData?.latitude,
//               longitude: propertyData?.longitude,
//               house_flat_block_no: propertyData?.house_flat_block_no,
//               address: propertyData?.address,
//             },
//           });
//         } catch (err) {
//           console.error("Payment flow error:", err);
//           // toast.error("Payment failed or interrupted");
//         }
//       }
//     } catch (error: any) {
//       console.error("Booking API error:", error);
//       // toast.error("Payment failed or cancelled, booking failed!");

//       // navigate("/payment-detail", {
//       //   state: {
//       //     amount: 1000,
//       //     email: formData.email,
//       //     contact: formData.country_code + formData.contact_number,
//       //     name: formData.fullName,
//       //     // booking_id,
//       //     property_name: propertyData?.property_name,
//       //     payment_status: "cancelled",
//       //     upi_id: "nestfin@upi",
//       //     upi_ref: "N/A",
//       //     latitude: propertyData?.latitude,
//       //     longitude: propertyData?.longitude,
//       //     house_flat_block_no: propertyData?.house_flat_block_no,
//       //     address: propertyData?.address,
//       //   },
//       // });
//     }
//   };
